/* Luvlyn · wat alle pagina's delen. Port van js/site.js uit de ontwerpsite (03-10-2026).
   1. De winkelwagen: de echte cart van Shopify (Cart-API, /cart/add.js en /cart/change.js). Na elke
      wijziging tekent Shopify de sectie met de lades opnieuw (Section Rendering API) en vervangen
      we alleen [data-mandje-inhoud], zodat de lade open blijft. Productsecties roepen
      Luvlyn.Mandje.erbij(variantId, aantal, naam) aan, of zetten data-in-mand op een knop (met
      data-variant, data-naam en data-hoeveel; niet data-aantal, dat is de teller in de kop).
   2. De lades: het menu (mobiel), de winkelwagen en zoeken (<dialog>, sections/lades.liquid). Plus het
      paneel Cadeau-ideeën in de kop (Escape, aria-expanded).
   3. Zoeken: pagina's en de vaakste vragen, zonder server (snippets/zoek-index.liquid), in de lade én
      bovenaan de zoekpagina (/search).
   4. Een vraag uit een link (#batterijen-hoe-lang) opent en licht op (data-vraag-id); in de chat tikt
      hij de vraag aan.
   5. De bezorgbelofte met de echte datum ([data-bezorg], [data-bezorg-kort], [data-cadeau-klok], de
      topbalk): de berekening staat in layout/theme.liquid (Luvlyn.bezorging), zodat de balk hem al heeft
      vóór de eerste tekening.
   6. De hoogte van de kop (--kop-h) voor ankers en alles wat onder de meelopende kop moet blijven.
   7. Het geluid: één speler voor de hele site (data-geluid), plus de harmonica.
   8. Vragen als een chat (data-chat).
   Teksten komen uit de taalbestanden (layout/theme.liquid zet ze in Luvlyn.tekst). */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const L = window.Luvlyn = window.Luvlyn || {};
  const T = L.tekst || {}, R = L.routes || {};
  const vul = (s, w) => String(s || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, k) => w[k] ?? '');
  const zacht = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Een melding (audit 04-10). Is er een lade open, dan in de lade: verborgen, role=status. De toast ligt dan
     achter de lade en is inert, dus een schermlezer hoorde hem niet. Met stil alleen voor schermlezers
     (het nieuwe aantal), anders de toast. */
  const toast = $('#toast'); let tt;
  // eerst leeg, dan de tekst: zo wordt ook dezelfde zin twee keer na elkaar voorgelezen
  function zeg(el, tekst){ el.textContent = ''; setTimeout(() => { el.textContent = tekst; }, 60); }
  function meld(tekst, stil = false){
    if (!tekst) return;
    const inLade = $('dialog.lade[open] [data-lade-melding]');
    if (inLade) return zeg(inLade, tekst);
    const verborgen = stil && $('[data-melding-stil]');
    if (verborgen) return zeg(verborgen, tekst);
    if (!toast) return;
    toast.textContent = tekst;
    toast.classList.add('aan'); clearTimeout(tt); tt = setTimeout(() => toast.classList.remove('aan'), 3400);
  }

  /* ---------- 1. de winkelwagen ----------
     Elk stuk winkelwagen op de pagina heeft data-mandje-inhoud="<sectie-id>": de lade, en op /cart
     ook de winkelwagenpagina (04-10). Na een wijziging tekent Shopify al die secties opnieuw. */
  const sectieIds = () => [...new Set($$('[data-mandje-inhoud]').map(el => el.dataset.mandjeInhoud).filter(Boolean))];
  function tekenMandje(secties){
    let aantal = null;
    Object.entries(secties || {}).forEach(([id, html]) => {
      if (!html) return;
      const nieuw = new DOMParser().parseFromString(html, 'text/html').querySelector(`[data-mandje-inhoud="${id}"]`);
      const oud = $(`[data-mandje-inhoud="${id}"]`);
      if (!nieuw || !oud) return;
      oud.replaceWith(nieuw);
      aantal = Number(nieuw.dataset.mandjeAantal || 0);
    });
    if (aantal === null) return;
    $$('[data-aantal]').forEach(b => { b.textContent = aantal; });
    // "Nog één, om weg te geven?" alleen als er iets in het winkelmandje ligt (audit 04-10)
    $$('[data-alleen-vol]').forEach(el => { el.hidden = aantal === 0; });
    werkTijdBij();
    document.dispatchEvent(new CustomEvent('mandje', { detail: { aantal } }));
  }
  async function stuur(pad, inhoud){
    const r = await fetch(`${pad}.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ ...inhoud, sections: sectieIds(), sections_url: location.pathname }),
    });
    const data = await r.json().catch(() => ({}));
    if (!r.ok) throw new Error(data.description || data.message || String(r.status));
    tekenMandje(data.sections);
    return data;
  }
  async function ververs(){
    const ids = sectieIds(); if (!ids.length) return;
    try {
      const r = await fetch(`${location.pathname}?sections=${encodeURIComponent(ids.join(','))}`);
      tekenMandje(await r.json());
    } catch {}
  }
  const Mandje = {
    async erbij(variantId, aantal = 1, naam = ''){
      try {
        await stuur(R.erbij, { items: [{ id: Number(variantId), quantity: Number(aantal) || 1 }] });
        if (naam) meld(vul(T.erin, { naam }));
        return true;
      } catch { meld(T.fout); return false; }
    },
    zet: (regel, aantal) => stuur(R.wijzig, { line: Number(regel), quantity: Math.max(0, aantal) }),
    ververs,
  };
  L.Mandje = Mandje;
  L.meld = meld;

  document.addEventListener('click', async e => {
    const knop = e.target.closest('[data-mandje-min], [data-mandje-plus], [data-mandje-weg]');
    const rij = knop && knop.closest('[data-regel]');
    if (rij){
      const regel = rij.dataset.regel, nu = Number(rij.dataset.aantalNu || 0);
      const welke = knop.hasAttribute('data-mandje-min') ? 'data-mandje-min' : knop.hasAttribute('data-mandje-plus') ? 'data-mandje-plus' : 'data-mandje-weg';
      const n = welke === 'data-mandje-min' ? nu - 1 : welke === 'data-mandje-plus' ? nu + 1 : 0;
      const naam = (rij.querySelector('small')?.textContent || '').split(' · ')[0].trim();
      const waar = knop.closest('[data-mandje-inhoud]')?.dataset.mandjeInhoud;
      const vak = () => $(`[data-mandje-inhoud="${waar}"]`) || document;
      $$('[data-mandje-inhoud]').forEach(el => el.classList.add('mandje-bezig'));
      try {
        await Mandje.zet(regel, n);
        // het nieuwe aantal en totaal voorlezen: de <output> in de regel is nieuw en werd niet aangekondigd (audit 04-10)
        if (n === 0) meld(naam ? vul(T.eruit, { naam }) : '');
        else meld(vul(T.aantalNu, { naam, aantal: n, totaal: ($('[data-mandje-totaal]', vak())?.textContent || '').trim() }), true);
        // de focus terug op dezelfde knop in hetzelfde stuk winkelwagen (lade of pagina)
        const terugNaar = $(`[data-regel="${regel}"] [${welke}]`, vak()) || (waar && $('[data-lade-dicht]', vak())) || $('[data-wm-verder]');
        terugNaar?.focus({ preventScroll: true });
      } catch {
        meld(T.fout);
        $$('[data-mandje-inhoud]').forEach(el => el.classList.remove('mandje-bezig'));
      }
      return;
    }
    const erin = e.target.closest('[data-in-mand][data-variant]');
    if (erin){
      e.preventDefault();
      const open = erin.hasAttribute('data-open-mandje'), naam = erin.dataset.naam || '';
      // met data-open-mandje komt "… ligt in je winkelmandje" in de lade zelf (beschrijving van de dialoog),
      // niet in de toast: die ligt achter de lade
      const ok = await Mandje.erbij(erin.dataset.variant, erin.dataset.hoeveel || 1, open ? '' : naam);
      if (!ok) return;
      if (open){
        const lade = $('[data-lade="mandje"]'), regel = lade && $('[data-lade-melding]', lade);
        const tekst = naam ? vul(T.erin, { naam }) : '';
        if (lade?.open){ if (regel && tekst) zeg(regel, tekst); }
        else { if (regel) regel.textContent = tekst; openLade('mandje', erin); }
      }
      // de knop is weg (hij stond in het lege winkelmandje, dat nu vol is): de focus naar de nieuwe regel
      if (!erin.isConnected){
        const d = $('dialog.lade[open]') || document;
        ($('[data-mandje-plus]', d) || $('[data-lade-dicht]', d))?.focus({ preventScroll: true });
      }
    }
  });
  // terug met de knop van de browser: de pagina komt uit het geheugen, de winkelwagen misschien niet
  addEventListener('pageshow', e => { if (e.persisted) ververs(); });

  /* ---------- 2. de lades ---------- */
  let terug = null;
  function openLade(naam, knop){
    const lade = $(`[data-lade="${naam}"]`); if (!lade || lade.open) return;
    $$('dialog.lade[open]').forEach(d => sluitLade(d, true));
    terug = knop || document.activeElement;
    lade.showModal();
    requestAnimationFrame(() => requestAnimationFrame(() => lade.classList.add('open')));
    document.documentElement.style.overflow = 'hidden';
    if (naam === 'zoek'){ const i = $('[data-zoek-invoer]', lade); i.value = ''; zoek(''); setTimeout(() => i.focus(), 60); }
  }
  function sluitLade(lade, meteen = false){
    if (!lade.open) return;
    lade.classList.remove('open');
    const klaar = () => {
      lade.close(); document.documentElement.style.overflow = '';
      const melding = $('[data-lade-melding]', lade); if (melding) melding.textContent = '';
      // de opener is er niet meer (vervangen): dan de kop van de pagina
      let t = terug && terug.isConnected ? terug : $('main h1');
      if (t && !t.matches('a[href], button, input, select, textarea, [tabindex]')) t.setAttribute('tabindex', '-1');
      t?.focus({ preventScroll: true });
    };
    if (meteen || zacht) return klaar();
    let weg = false; const een = () => { if (!weg){ weg = true; klaar(); } };
    lade.addEventListener('transitionend', een, { once: true }); setTimeout(een, 520);
  }
  L.openLade = openLade;
  document.addEventListener('click', e => {
    const open = e.target.closest('[data-lade-open]');
    if (open){ e.preventDefault(); openLade(open.dataset.ladeOpen, open); return; }
    const dicht = e.target.closest('[data-lade-dicht]');
    if (dicht){ sluitLade(dicht.closest('dialog')); return; }
    // een tik op de waas naast de lade
    if (e.target.matches('dialog.lade')){
      const r = e.target.getBoundingClientRect();
      if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) sluitLade(e.target);
    }
    // een link in een lade naar deze pagina (bijvoorbeeld een vraag): eerst dicht
    const a = e.target.closest('dialog.lade a[href]');
    if (a){ const l = a.closest('dialog'); l.classList.remove('open'); l.close(); document.documentElement.style.overflow = ''; }
  });
  $$('dialog.lade').forEach(d => d.addEventListener('cancel', e => { e.preventDefault(); sluitLade(d); }));
  $$('.lade-hoofd a, .lade-klein a, .lade-menu-voet').forEach((a, i) => a.style.setProperty('--i', Math.min(i, 12)));

  /* het paneel Cadeau-ideeën in de kop (computer). Het opent met de muis of de tab (luvlyn.css, :hover en
     :focus-within). Hier: aria-expanded bijhouden, Escape sluit het (ook als alleen de muis erop staat; de focus
     gaat terug naar de link) en pijl omlaag opent het weer en gaat naar de eerste link (audit 04-10, WCAG 1.4.13). */
  const UIT = $$('[data-kop-uit]');
  const uitOpen = uit => uit.matches(':hover, :focus-within') && !uit.classList.contains('dicht');
  const uitZet = uit => $(':scope > a', uit)?.setAttribute('aria-expanded', String(uitOpen(uit)));
  UIT.forEach(uit => {
    const a = $(':scope > a', uit);
    const later = () => setTimeout(() => { if (!uit.matches(':hover, :focus-within')) uit.classList.remove('dicht'); uitZet(uit); });
    ['mouseenter', 'focusin'].forEach(ev => uit.addEventListener(ev, () => uitZet(uit)));
    ['mouseleave', 'focusout'].forEach(ev => uit.addEventListener(ev, later));
    a?.addEventListener('keydown', e => {
      if (e.key !== 'ArrowDown') return;
      e.preventDefault(); uit.classList.remove('dicht'); uitZet(uit);
      requestAnimationFrame(() => $('.kop-uit-paneel a', uit)?.focus());
    });
  });
  if (UIT.length) document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    UIT.forEach(uit => {
      if (!uitOpen(uit)) return;
      uit.classList.add('dicht');
      if (uit.contains(document.activeElement)) $(':scope > a', uit)?.focus();
      uitZet(uit);
    });
  });

  /* ---------- 3. zoeken ---------- */
  let Z = { lijst: [], veel: [] };
  try { Z = JSON.parse($('[data-zoek-index]')?.textContent || '') || Z; } catch {}
  const norm = s => s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const uitkomst = $('[data-zoek-uitkomst]'), invoer = $('[data-zoek-invoer]');
  const pijl = '<svg class="ic" aria-hidden="true"><use href="#i-pijl"/></svg>';
  const veilig = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
  const markeer = (t, w) => w.reduce((s, x) => x ? s.replace(new RegExp(`(${x.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'ig'), '<mark>$1</mark>') : s, veilig(t));
  // de eigen lijst doorzoeken: elk woord moet in titel, groep, zoekwoorden of antwoord staan; leeg = "veel gezocht"
  function vind(q){
    const woorden = norm(q).split(/\s+/).filter(w => w.length > 1);
    let lijst = Z.lijst;
    if (woorden.length) lijst = Z.lijst.filter(([t, , s, w, a]) => woorden.every(x => norm(`${t} ${s} ${w} ${a || ''}`).includes(x)));
    if (!q.trim()) lijst = Z.veel.map(u => Z.lijst.find(r => r[1] === u)).filter(Boolean);
    return { lijst, woorden };
  }
  // de uitkomsten per groep (Shop, Vraag, Gids, Hulp), met kop (h3 in de lade, h2 op de zoekpagina) of zonder
  const groepen = (lijst, woorden, kop) => ['Shop', 'Vraag', 'Gids', 'Hulp'].map(g => [g, lijst.filter(r => r[2] === g)]).filter(([, r]) => r.length)
    .map(([g, r]) => (kop ? `<${kop}>${veilig((T.groepen || {})[g] || g)}</${kop}>` : '') + r.map(([t, u, , , a]) => `<a href="${veilig(u)}"><span>${markeer(t, woorden)}${a ? `<small>${veilig(a)}</small>` : ''}</span>${pijl}</a>`).join('')).join('');
  let eerste = null;
  function zoek(q){
    if (!uitkomst) return;
    const { lijst, woorden } = vind(q);
    eerste = q.trim() && lijst.length ? lijst[0][1] : null;
    uitkomst.innerHTML = (q.trim() ? '' : `<h3>${veilig(T.veel || '')}</h3>`) + (groepen(lijst, woorden, q.trim() ? 'h3' : '') || `<p>${veilig(vul(T.niets, { zoekterm: q }))}</p>`);
  }
  if (invoer){
    invoer.addEventListener('input', () => zoek(invoer.value));
    // Enter: naar de eerste uitkomst; zonder uitkomst de zoekpagina van Shopify
    invoer.form?.addEventListener('submit', e => { if (eerste){ e.preventDefault(); location.href = eerste; } });
  }
  /* de zoekpagina (/search, sections/luvlyn-zoeken.liquid): bovenaan dezelfde eigen lijst als de lade, daaronder
     wat Shopify vond en nog niet boven stond, onder één kop "Ook gevonden"; het aantal telt opnieuw (audit 04-10:
     "geluid" vond de geluidenpagina niet, de lade wel). Zonder script blijft het de lijst van Shopify. */
  const zp = $('[data-zoek-pagina]');
  if (zp){
    const { lijst, woorden } = vind(zp.dataset.zoekPagina || '');
    const html = woorden.length ? groepen(lijst, woorden, 'h2') : '';
    if (html){
      const eigen = document.createElement('div');
      eigen.className = 'zk-groep zk-eigen'; eigen.innerHTML = html;
      const al = new Set(lijst.map(r => r[1]));
      const pad = a => { try { return new URL(a.href, location.href).pathname; } catch { return a.getAttribute('href'); } };
      const shopify = $$('[data-zk-groep]', zp);
      const rest = shopify.flatMap(g => $$('a', g)).filter(a => !al.has(pad(a)));
      if (rest.length){
        const ook = document.createElement('div');
        ook.className = 'zk-groep'; ook.innerHTML = `<h2>${veilig(T.ook || '')}</h2>`;
        rest.forEach(a => ook.append(a));
        shopify[0].before(ook);
      }
      shopify.forEach(g => g.remove());
      $('[data-zoek-leeg]', zp)?.remove();
      zp.prepend(eigen);
      const tel = $('[data-zk-aantal]');
      if (tel) tel.textContent = tel.dataset.zkAantal.replace('[aantal]', $$('.zk-groep a', zp).length);
    }
  }

  /* ---------- 4. een vraag uit de link openen ---------- */
  function openVraag(){
    const id = decodeURIComponent(location.hash.slice(1));
    if (!id) return;
    const el = $(`[data-vraag-id="${CSS.escape(id)}"]`);
    if (!el) return;
    if (el.tagName === 'DETAILS') el.open = true;
    const d = el.closest('details'); if (d) d.open = true;
    // een vraag in de chat: aantikken, zodat het antwoord er ook staat
    if (el.matches('[data-chat] [data-vraag]') && el.getAttribute('aria-pressed') !== 'true') el.click();
    setTimeout(() => el.scrollIntoView({ block: 'start', behavior: zacht ? 'instant' : 'smooth' }), 80);
    el.classList.remove('uitgelicht'); void el.offsetWidth; el.classList.add('uitgelicht');
  }
  addEventListener('hashchange', openVraag);

  /* ---------- 5. de bezorgbelofte ----------
     Luvlyn.bezorging en Luvlyn.vulBalk staan in layout/theme.liquid (de topbalk vult zich vóór de eerste tekening). */
  function duur(ms){
    const m = Math.max(1, Math.ceil(ms / 6e4)), u = Math.floor(m / 60), r = m % 60;
    return u ? `${u} uur${r ? ` en ${r} min` : ''}` : `${r} min`;
  }
  function werkTijdBij(){
    if (!L.bezorging) return;
    const b = L.bezorging(), dag = b.werkdag ? 'Vandaag' : 'Nu';
    const lang = b.optijd ? vul(T.bezorgBinnen, { duur: duur(b.rest), wanneer: b.wanneer }) : vul(T.bezorgLater, { dag, wanneer: b.wanneer });
    $$('[data-bezorg]').forEach(el => { el.innerHTML = lang; });
    $$('[data-bezorg-kort]').forEach(el => { el.textContent = `${b.optijd ? 'Vandaag' : dag} besteld, ${b.wanneer.split(' (')[0]} in huis`; });
    // de topbalk: zelfde dag als het koopblok (review 04-10: de balk zei "morgen", het koopblok "overmorgen")
    L.vulBalk?.();
    $$('[data-cadeau-klok]').forEach(el => {
      el.innerHTML = b.optijd
        ? `Nog <b>${duur(b.rest)}</b> tot 17:00. Dan ligt hij ${b.wanneer} bij je in huis.`
        : `${dag} besteld, ${b.wanneer} bij je in huis.`;
    });
  }

  /* ---------- 6. de hoogte van de kop (--kop-h) ----------
     Alleen schrijven als de hoogte echt verandert (laden, letters, draaien van het scherm): niet per beeld op :root,
     dat kostte bij scrollen een stijlberekening van de hele pagina per beeld (audit 04-10). De kop verandert bij
     scrollen niet meer van hoogte: op mobiel klappen de snelle links alleen zichtbaar in (luvlyn.css, clip-path).
     --kop-inklap (op de kop zelf) is hoeveel er dan weggeknipt wordt: alles onder de bovenste rij, op 12 px na. */
  const kop = $('.sectie[data-id="kop"]');
  if (kop && 'ResizeObserver' in window){
    let was = '';
    // offsetTop/offsetHeight: de maat zonder transform (de kop komt binnen met een translate, kop-in in luvlyn.css)
    const onder = el => { let y = el.offsetHeight; for (let e = el; e && e !== kop; e = e.offsetParent) y += e.offsetTop; return y; };
    new ResizeObserver(() => {
      const h = `${kop.offsetHeight}px`;
      if (h !== was){ was = h; document.documentElement.style.setProperty('--kop-h', h); }
      const boven = $('.kp3-boven', kop);
      const inklap = boven && boven.offsetParent ? Math.max(0, kop.offsetHeight - onder(boven) - 12) : 0;
      kop.style.setProperty('--kop-inklap', `${inklap}px`);
    }).observe(kop);
  }

  /* ---------- 7. het geluid: één speler voor de hele site ----------
     Elke knop met data-geluid="<sleutel>" speelt dat geluid (de fragmenten zijn de metaobjecten
     "geluid", in layout/theme.liquid als #luvlyn-geluiden). De golfjes (.lu-golf) bewegen mee met het
     echte geluid via Web Audio; Shopify's CDN stuurt CORS mee, dus dat mag. Seintje 'geluid' (wie:
     'secties') voor het speler-pop-upje in beweging.js en voor de productpagina. De hero op de home
     heeft een eigen speler (assets/home.js); die stopt als deze begint, en andersom. */
  const GELUID = (() => { try { return JSON.parse($('#luvlyn-geluiden')?.textContent || '{}'); } catch { return {}; } })();
  const audio = new Audio(); audio.preload = 'none'; audio.crossOrigin = 'anonymous';
  let nu = null, knopBron = null, ctx = null, analyser = null, freq = null, raf = null;
  function verbind(){
    try {
      if (!ctx){
        ctx = new (window.AudioContext || window.webkitAudioContext)();
        const b = ctx.createMediaElementSource(audio);
        analyser = ctx.createAnalyser(); analyser.fftSize = 64; analyser.smoothingTimeConstant = .75;
        b.connect(analyser); analyser.connect(ctx.destination);
        freq = new Uint8Array(analyser.frequencyBinCount);
      }
      if (ctx.state === 'suspended') ctx.resume();
    } catch { analyser = null; }
  }
  function teken(){
    raf = null;
    const knoppen = $$('[data-geluid].speelt');
    if (!knoppen.length || !analyser) return;
    analyser.getByteFrequencyData(freq);
    knoppen.forEach(b => $$('.lu-golf i', b).forEach((g, n) => g.style.setProperty('--v', (freq[2 + n * 2] / 255).toFixed(3))));
    raf = requestAnimationFrame(teken);
  }
  function speel(g, knop){
    if (!GELUID[g]) return;
    if (nu === g && !audio.paused) { audio.pause(); return; }
    knopBron = knop || knopBron;
    $('[data-luister-pil].speelt [data-luister-stop]')?.click();   // de hero-speler eerst stil
    nu = g; audio.src = GELUID[g].bron; verbind(); audio.play().catch(() => {});
  }
  function geluidStatus(){
    const speelt = !audio.paused && !audio.ended;
    $$('[data-geluid]').forEach(b => {
      const aan = speelt && b.dataset.geluid === nu;
      b.classList.toggle('speelt', aan);
      b.classList.toggle('echt', aan && !!analyser);
      const use = $('.speel-ic use', b); if (use) use.setAttribute('href', aan ? '#i-pauze' : '#i-speel');
      $('.speel-ic svg', b)?.classList.toggle('vol', !aan);
    });
    $$('[data-rooster]').forEach(r => r.classList.toggle('speelt', speelt));
    if (speelt && analyser && !raf) raf = requestAnimationFrame(teken);
    document.dispatchEvent(new CustomEvent('geluid', { detail: { wie: 'secties', speelt, naam: GELUID[nu]?.naam, bron: knopBron, stop: () => audio.pause() } }));
  }
  ['play', 'pause', 'ended'].forEach(ev => audio.addEventListener(ev, geluidStatus));
  document.addEventListener('click', e => { const b = e.target.closest('[data-geluid]'); if (b) speel(b.dataset.geluid, b); });
  // de hero begint: deze speler stopt
  document.addEventListener('geluid', ({ detail: d }) => { if (d.wie === 'hero' && d.speelt && !audio.paused) audio.pause(); });
  Object.assign(L, { geluiden: GELUID, speel });

  // harmonica (Luister maar, home): een tik op een dicht paneel opent het; het geluid speelt via data-geluid
  $$('[data-harmonica]').forEach(h => {
    const knoppen = $$('[data-geluid]', h);
    knoppen.forEach(k => k.addEventListener('click', () => knoppen.forEach(q => {
      q.parentElement.classList.toggle('open', q === k);
      q.setAttribute('aria-expanded', String(q === k));
    })));
  });

  /* ---------- 8. vragen als een chat ----------
     De vraag verschijnt rechts, het vogeltje "typt" en antwoordt. Eén vraag tegelijk; alleen de
     begroeting blijft staan (sections/luvlyn-vragen-chat.liquid). Het gesprek scrolt zelf; een nieuw
     antwoord komt zo in beeld dat je de vraag en het begin van het antwoord ziet. Tot 04-10 scrolde het
     naar de onderkant, en bij het laden niet: op mobiel stond het eerste antwoord maar half in beeld. */
  $$('[data-chat]').forEach(el => {
    const log = $('[data-chat-log]', el);
    const toon = (paar, hoe) => {
      const top = log.scrollTop + paar.getBoundingClientRect().top - log.getBoundingClientRect().top - 12;
      log.scrollTo({ top: Math.max(0, Math.min(top, log.scrollHeight - log.clientHeight)), behavior: hoe || (zacht ? 'instant' : 'smooth') });
    };
    const flits = b => { b.classList.remove('nieuw'); void b.offsetWidth; b.classList.add('nieuw'); };
    let bezig = false;
    $$('[data-vraag]', el).forEach(chip => chip.addEventListener('click', () => {
      const paar = $(`[data-paar="${chip.dataset.vraag}"]`, log);
      if (!paar || bezig) return;
      const [vraag, antwoord] = $$('.fq4-bel', paar);
      if (!paar.hidden && !antwoord.hidden){ flits(antwoord); toon(paar); return; }
      bezig = true;
      $$('[data-vraag]', el).forEach(c => c.setAttribute('aria-pressed', String(c === chip)));
      $$('[data-paar]', log).forEach(p => { p.hidden = p !== paar; });
      antwoord.hidden = true; paar.hidden = false; flits(vraag);
      const typt = document.createElement('p');
      typt.className = 'fq4-bel van-ons fq4-typt nieuw';
      typt.setAttribute('aria-label', T.typt || 'Luvlyn typt');
      typt.innerHTML = '<i></i><i></i><i></i>';
      paar.append(typt); toon(paar);
      setTimeout(() => { typt.remove(); antwoord.hidden = false; flits(antwoord); toon(paar); bezig = false; }, zacht ? 0 : 950);
    }));
    // bij het laden: het eerste antwoord in beeld (het gesprek zelf, niet de pagina)
    const eerstePaar = $$('[data-paar]', log).find(p => !p.hidden);
    if (eerstePaar) requestAnimationFrame(() => toon(eerstePaar, 'instant'));
  });

  /* ---------- 9. cookies: standaard aan, een kleine melding onderaan, uitzetten in de voet ----------
     Keuze Cehdi 20-10 (terug naar optie 3 van 05-10, nu met een melding): wie nog niets koos, krijgt alles aan via
     de Customer Privacy API van Shopify (setTrackingConsent); de Google & YouTube-app leest die keuze. Een kleine
     balk [data-cookie-melding] zegt dat er cookies zijn, tot de bezoeker op Oké of Wijzigen klikt (onthouden in
     localStorage). Wijzigen en "Cookie-instellingen" in de voet openen [data-lade="cookies"] (sections/voet.liquid);
     een keuze daar blijft staan. De banner van Shopify zelf is niet aangemaakt in de admin. Het risico (geen
     geldige toestemming volgens de AP en het EU-toestemmingsbeleid van Google) is met Cehdi besproken, zie
     werkmappen/Luvlyn/ads/PROJECT.md in het Prive-Brein, logboek 20-10. Van 08-10 tot 20-10 stond hier opt-in. */
  const SOORTEN = ['analytics', 'preferences', 'marketing'];
  const MELDING = 'lv-cookiemelding';
  const privacy = () => new Promise(klaar => {
    if (window.Shopify?.customerPrivacy) return klaar(window.Shopify.customerPrivacy);
    if (typeof window.Shopify?.loadFeatures !== 'function') return klaar(null);
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], fout => klaar(fout ? null : window.Shopify.customerPrivacy || null));
  });
  const zetCookies = (cp, keus) => new Promise(klaar => cp.setTrackingConsent({ ...keus, sale_of_data: keus.marketing }, () => klaar()));
  const gezien = () => { try { return localStorage.getItem(MELDING) === '1'; } catch { return null; } };
  const onthoud = () => { try { localStorage.setItem(MELDING, '1'); } catch {} };
  privacy().then(cp => {
    if (!cp) return;
    const nu = () => (typeof cp.currentVisitorConsent === 'function' && cp.currentVisitorConsent()) || {};
    const nieuw = !SOORTEN.some(k => nu()[k] === 'yes' || nu()[k] === 'no');
    if (nieuw) zetCookies(cp, { analytics: true, preferences: true, marketing: true });
    const keuze = $('[data-cookie-keuze]'), lade = $('[data-lade="cookies"]'), form = lade && $('[data-cookie-form]', lade);
    if (!keuze || !form) return;
    keuze.hidden = false;
    const openKeuze = knop => {
      SOORTEN.forEach(k => { form.elements[k].checked = nu()[k] !== 'no'; });
      openLade('cookies', knop);
    };
    $('button', keuze).addEventListener('click', e => openKeuze(e.currentTarget));
    const bewaar = async keus => { onthoud(); await zetCookies(cp, keus); sluitLade(lade); meld(lade.dataset.opgeslagen); };
    form.addEventListener('submit', e => { e.preventDefault(); bewaar(Object.fromEntries(SOORTEN.map(k => [k, form.elements[k].checked]))); });
    $('[data-cookie-uit]', form).addEventListener('click', () => { SOORTEN.forEach(k => { form.elements[k].checked = false; }); bewaar({ analytics: false, preferences: false, marketing: false }); });
    // de melding: tot Oké of Wijzigen; zonder localStorage alleen bij het eerste bezoek
    const melding = $('[data-cookie-melding]');
    if (!melding || (gezien() ?? !nieuw)) return;
    melding.hidden = false;
    const weg = () => { onthoud(); melding.hidden = true; };
    $('[data-cookie-ok]', melding).addEventListener('click', weg);
    $('[data-cookie-wijzig]', melding).addEventListener('click', () => { weg(); openKeuze($('button', keuze)); });
  });

  /* ---------- opbouw ---------- */
  werkTijdBij();
  setInterval(() => { if (!document.hidden) werkTijdBij(); }, 30000);
  requestAnimationFrame(openVraag);
})();
